<app-search
  class="block mb-2 w-full md:w-[50%]"
  [placeholder]="'Search by User Name or Company'"
  (onSearch)="onSearch($event)">
</app-search>
<div class="mb-2 flex flex-wrap items-center justify-between gap-3">
  <p class="text-xl">{{title}}</p>
  <button
    mat-stroked-button
    type="button"
    [matMenuTriggerFor]="exportMenu"
    [disabled]="loading || totalCount === 0 || isExporting">
    {{ isExporting ? 'Exporting...' : 'Export' }}
  </button>
</div>
<mat-menu #exportMenu="matMenu">
  <button mat-menu-item type="button" (click)="exportUsers('pdf')">PDF (.pdf)</button>
  <button mat-menu-item type="button" (click)="exportUsers('xlsx')">Excel (.xlsx)</button>
</mat-menu>
<hr/>
<div class="flex flex-row flex-wrap gap-4 my-4 justify-between">
  <div class="flex flex-wrap gap-4">
    <details class="filter-menu-trigger group">
      <summary class="inline-flex w-full cursor-pointer list-none justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm border border-gray-200 text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 [&::-webkit-details-marker]:hidden">
        User Type
        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-1 size-5 text-gray-400 transition-transform group-open:rotate-180">
          <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
        </svg>
      </summary>

      <div class="mt-2 rounded-md border border-gray-200 bg-white p-4 shadow-sm">
        <app-filter-checkbox [label]="'USER TYPE'" [selectedItems]="filters.accountTypes" [items]="userTypeItems" (selectionSubmitted)="onAccountTypeFilter($event)"></app-filter-checkbox>
      </div>
    </details>
    <details class="filter-menu-trigger group">
      <summary class="inline-flex w-full cursor-pointer list-none justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm border border-gray-200 text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 [&::-webkit-details-marker]:hidden">
        Status
        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-1 size-5 text-gray-400 transition-transform group-open:rotate-180">
          <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
        </svg>
      </summary>

      <div class="mt-2 rounded-md border border-gray-200 bg-white p-4 shadow-sm">
        <app-filter-checkbox [label]="'STATUS'" [selectedItems]="filters.status" [items]="statusItems" (selectionSubmitted)="onStatusFilter($event)"></app-filter-checkbox>
      </div>
    </details>

    <details class="filter-menu-trigger group">
      <summary class="inline-flex w-full cursor-pointer list-none justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm border border-gray-200 text-gray-900 shadow-xs inset-ring-1 inset-ring-gray-300 hover:bg-gray-50 [&::-webkit-details-marker]:hidden">
        Date Range
        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="-mr-1 size-5 text-gray-400 transition-transform group-open:rotate-180">
          <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
        </svg>
      </summary>

      <div class="mt-2 rounded-md border border-gray-200 bg-white p-4 shadow-sm">
        <app-date-type-filter [formValue]="filters.dateTypeFilter" (formChanged)="onDateFilter($event)"></app-date-type-filter>
      </div>
    </details>
  </div>
  <div class="filter-menu-trigger">
    @if (filters.accountTypes.length !== 0) {
      <div>
        <div class="text-right">User Types</div>
        <div class="flex flex-wrap gap-2 my-4 justify-end">
          @for (tag of filters.accountTypes; track tag) {
            <span
              class="px-3 py-1 text-xs font-semibold text-white rounded-full bg-indigo-500 flex flex-row gap-1">
              <span>{{ getUserTypeName(tag) }}</span><button (click)="removeUserTypeTag(tag)">&#x2715;</button>
            </span>
          }
        </div>
      </div>
    }
    @if (filters.status.length !== 0) {
      <div >
        <div class="text-right">Status</div>
        <div class="flex flex-wrap gap-2 my-4 justify-end">
          @for (tag of filters.status; track tag) {
            <span
              class="px-3 py-1 text-xs font-semibold text-white rounded-full bg-fuchsia-500 flex flex-row gap-1">
              <span>{{ getStatusName(tag) }}</span><button (click)="removeStatusTag(tag)">&#x2715;</button>
            </span>
          }
        </div>
      </div>
    }
    @if (hasActiveDateFilter) {
      <div>
        <div class="text-right">Date Type</div>
        <div class="flex flex-wrap gap-2 my-4 justify-end">
          <span
            class="px-3 py-1 text-xs font-semibold text-white rounded-full bg-red-400 flex flex-row gap-1">
            <span>{{ getDateFilterName }}: {{filters.dateTypeFilter?.startDate ? (filters.dateTypeFilter?.startDate | dateFormat): 'Any'}} - {{filters.dateTypeFilter?.endDate ? (filters.dateTypeFilter?.endDate | dateFormat): 'Any'}}</span><button (click)="removeDateTag()">&#x2715;</button>
          </span>
        </div>
      </div>
    }
    <div class="text-right">@if (dataFiltered) {
      <a
        class="inline-block cursor-pointer max-h-fit py-1 text-link-blue hover:underline"
        role="button"
        tabindex="0"
        (click)="clearAllFilters()"
        (keydown.enter)="clearAllFilters()"
        (keydown.space)="clearAllFilters()">
        Clear all filters
      </a>
    }
  </div>
</div>
</div>

<hr
  class="bg-green"
  [ngStyle]="{
    width: '100%',
    'min-width': tableDataSource.data.length > 0 ? '683px' : '580px',
    height: '3px',
    border: 'none'
  }"
  />
<app-load-spinner-wrapper [loading]="loading">
  <div class="w-full min-w-0 max-w-full max-h-[60dvh] overflow-x-auto overflow-y-auto touch-auto">
  <table
    class="mb-8"
    mat-table
    matSort
    matSortActive="lastLogin"
    matSortDirection="desc"
    matSortDisableClear
    [dataSource]="tableDataSource"
    (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'user type' | upperCase}} </th>
      <td mat-cell *matCellDef="let user"> {{user.accountType}} </td>
    </ng-container>
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'user name' | upperCase}} </th>
      <td mat-cell *matCellDef="let user">
        <span
          tabindex="0"
          role="button"
          class="cursor-pointer"
          (click)="openUserInfoModal(user)"
          (keydown.enter)="openUserInfoModal(user)"
          (keydown.space)="openUserInfoModal(user)">
          {{user.userName}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'company/clinic' | upperCase}} </th>
      <td mat-cell *matCellDef="let user"> {{user.company}} </td>
    </ng-container>
    <ng-container matColumnDef="registration">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'registration' | upperCase }} </th>
      <td mat-cell *matCellDef="let user"> {{user.registration | dateFormat:'MM/DD/YYYY'}} </td>
    </ng-container>
    <ng-container matColumnDef="lastLogin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'last login' | upperCase }} </th>
      <td mat-cell *matCellDef="let user"> {{user.lastLogin | dateFormat:'MM/DD/YYYY'}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'status' | upperCase}} </th>
      <td mat-cell *matCellDef="let user"> {{user.userStatus}} </td>
    </ng-container>
    <tr class="sticky top-0 z-10 bg-white" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
  @if (tableDataSource.data.length === 0) {
    <div
      class="w-full text-center my-10"
      >
      <p class="text-sm">{{noResultsMessageToShow}}</p>
    </div>
  }
  @if (tableDataSource.data.length > 0) {
    <div
      class="sticky bottom-0 z-10 flex justify-end bg-white"
      >
      <app-pagination
        [currentPage]="pageSearchSortOptions.pageNumber"
        [totalPages]="totalPages"
        (pageChange)="onPageChange($event)"
        />
    </div>
  }
</app-load-spinner-wrapper>
